import { IIssue } from "dto/Helpdesk/IIssue";
import { createContext } from "react";

type IIssuesContext = {
  issues: IIssue[];
  setIssues: (issues: IIssue[]) => void;
};

const IssuesContext = createContext<IIssuesContext>({
  issues: [],
  setIssues: () => {},
});

export default IssuesContext;
